module.exports = __webpack_public_path__ + "img/hero-banner-3.37599e9f.jpg";